import styled from "styled-components";

export const StakesContainer = styled.div``;

export const StakesCard = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid #7b36ee;
  border-radius: 10px;
  padding: 10px 30px;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;